var map = {
	"assets/images/relics/ALC/relic_tool-g_t_skysteel-p_t_augmented_dragonsung.png": 9766,
	"assets/images/relics/ALC/relic_tool-g_t_skysteel-p_t_skybuilders.png": 8307,
	"assets/images/relics/ALC/relic_tool-g_t_skysteel-p_t_skysung.png": 6765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2085;